import clsx from '@/lib/clsx';
import WizardRadio from './WizardRadio';

const WizardRadioCards = ({ options, value, onChange, className = '', getKey, autoFocus = false, ...props }) => {
  const normalizedOptions = Array.isArray(options) ? options : [];

  return (
    <div className={clsx('comp-wizard-radio-cards', className)} {...props}>
      {normalizedOptions.map((option, index) => {
        const key = getKey ? getKey(option, index) : (option?.value ?? index);
        const isSelected = option?.value === value;

        return (
          <WizardRadio //
            key={key}
            value={option}
            checked={isSelected}
            onChange={onChange}
            label={option?.label}
            description={option?.description}
            icon={option?.icon}
            autoFocus={autoFocus && index === 0}
          />
        );
      })}
    </div>
  );
};

export default WizardRadioCards;
